import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { CardModule } from 'primeng/card';
import { CheckboxModule } from 'primeng/checkbox';
import { TabMenuModule } from 'primeng/tabmenu';
import { MenubarModule } from 'primeng/menubar';
import { MenuModule } from 'primeng/menu';
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { DividerModule } from 'primeng/divider';
import { RippleModule } from 'primeng/ripple';
import { CalendarModule } from 'primeng/calendar';
import { FieldsetModule } from 'primeng/fieldset';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { AccordionModule } from 'primeng/accordion';
import { ProgressBarModule } from 'primeng/progressbar';
import { TabViewModule } from 'primeng/tabview';
import { AuthGuardService } from '../../guards/auth-guard.service';
import { SharedModule } from '../../shared/shared.module';
import { AppMainComponent } from '../../app.main.component';
import { OrdersComponent } from './orders.component';
import { OrdersRawMaterialsComponent } from './orders-raw-materials/orders-raw-materials.component';
import {
    OrderRawMaterialAddEditComponent
} from './orders-raw-materials/order-raw-material-add-edit/order-raw-material-add-edit.component';
import { OrdersCustomerComponent } from './orders-customer/orders-customer.component';
import {
    OrdersCustomerAddEditComponent
} from './orders-customer/orders-customer-add-edit/orders-customer-add-edit.component';
import {
    OrdersCustomerActionTableComponent
} from './orders-customer/orders-customer-action-table/orders-customer-action-table.component';
import {
    OrderRawMaterialsActionTableComponent
} from './orders-raw-materials/order-raw-materials-action-table/order-raw-materials-action-table.component';
import {
    OrdersCustomersTransportComponent
} from './orders-customer/orders-customers-transport/orders-customers-transport.component';
import {
    OrdersRawMaterialsReceptionNoteComponent
} from './orders-raw-materials/orders-raw-materials-reception-note/orders-raw-materials-reception-note.component';
import {
    OrdersCustomersTransportViewComponent
} from './orders-customer/orders-customers-transport-view/orders-customers-transport-view.component';
import {
    OrderCustomersTransportProgressbarComponent
} from './orders-customer/orders-customers-transport/order-customers-transport-progressbar/order-customers-transport-progressbar.component';
import {
    OrdersCustomersTransportViewActionTableComponent
// eslint-disable-next-line max-len
} from './orders-customer/orders-customers-transport-view/orders-customers-transport-view-action-table/orders-customers-transport-view-action-table.component';
import {
    OrdersCustomersTransportViewAddEditComponent
// eslint-disable-next-line max-len
} from './orders-customer/orders-customers-transport-view/orders-customers-transport-view-add-edit/orders-customers-transport-view-add-edit.component';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { OrdersCustomersTransportMapComponent } from './orders-customer/orders-customers-transport-map/orders-customers-transport-map.component';
import { OrdersCustomerTransportMapProgressBarComponent } from './orders-customer/orders-customers-transport-map/orders-customer-transport-map-progress-bar/orders-customer-transport-map-progress-bar.component';


const routes: Routes = [
    { path: 'orders', redirectTo: 'orders/customer/list', pathMatch: 'full' },
    {
        path: 'orders', component: AppMainComponent,
        children: [
            {
                path: 'customer', canActivate: [AuthGuardService], data: {roles : ['Administrator', 'Gestionar', 'Logistica']},
                children: [
                    { path: 'list', component: OrdersCustomerComponent, canActivate: [AuthGuardService], data: {roles : ['Administrator', 'Gestionar', 'Logistica']} },
                    { path: 'add-edit', component: OrdersCustomerAddEditComponent, canActivate: [AuthGuardService], data: {roles : ['Administrator', 'Gestionar', 'Logistica']} },
                    { path: 'transport-view', component: OrdersCustomersTransportViewComponent, canActivate: [AuthGuardService], data: {roles : ['Administrator', 'Gestionar']} },
                    { path: 'transport-map', component: OrdersCustomersTransportMapComponent, canActivate: [AuthGuardService], data: {roles : ['Administrator', 'Logistica']} },
                    { path: '', redirectTo: 'list', pathMatch: 'full' },
                ]
            },
            {
                path: 'raw-materials', canActivate: [AuthGuardService], data: {roles : ['Administrator', 'Gestionar', 'Logistica', 'Achizitii']},
                children: [
                    { path: 'list', component: OrdersRawMaterialsComponent, canActivate: [AuthGuardService], data: {roles : ['Administrator', 'Gestionar', 'Logistica', 'Achizitii']}},
                    { path: 'add-edit', component: OrderRawMaterialAddEditComponent, canActivate: [AuthGuardService],data: {roles : ['Administrator', 'Gestionar', 'Logistica', 'Achizitii']}},
                    { path: '', redirectTo: 'list', pathMatch: 'full' },
                ]
            },
        ]
    },
];

@NgModule({
    declarations: [
        OrdersComponent,
        OrdersRawMaterialsComponent,
        OrderRawMaterialAddEditComponent,
        OrdersCustomerComponent,
        OrdersCustomerAddEditComponent,
        OrdersCustomerActionTableComponent,
        OrderRawMaterialsActionTableComponent,
        OrdersCustomersTransportComponent,
        OrdersRawMaterialsReceptionNoteComponent,
        OrdersCustomersTransportViewComponent,
        OrderCustomersTransportProgressbarComponent,
        OrdersCustomersTransportViewActionTableComponent,
        OrdersCustomersTransportViewAddEditComponent,
        OrdersCustomersTransportMapComponent,
        OrdersCustomerTransportMapProgressBarComponent,
    ],
    imports: [
        CommonModule,
        ButtonModule,
        FormsModule,
        TabMenuModule,
        DropdownModule,
        InputTextModule,
        ProgressBarModule,
        FieldsetModule,
        ReactiveFormsModule,
        CalendarModule,
        SharedModule,
        MenubarModule,
        TableModule,
        DividerModule,
        MenuModule,
        RouterModule.forRoot(routes, {scrollPositionRestoration: 'enabled'}),
        RippleModule,
        InputTextareaModule,
        AccordionModule,
        CheckboxModule,
        TabViewModule,
        CardModule,
        ConfirmDialogModule,
    ]
})
export class OrdersModule {
}
